export interface CheckAccountRes {
  phone: string;
  sign_in: boolean;
}

export const CheckAccountApi = Symbol.for('CheckAccountApi');

export interface CheckAccountApi {
  checkAccount(phone: string): Promise<CheckAccountRes>;
}
